function Projects() {
  const projects = [
    {
      name: "GaadiyaHub",
      description: "Live vehicle marketplace on AWS with 10 microservices on K3s Kubernetes. Full production platform with CI/CD, monitoring and IaC.",
      link: "https://gadiyahub.com",
      github: "https://github.com/A2Z-Vehicle-Soulution/gaadiyadekho-platform",
      tech: ["K3s", "Kubernetes", "AWS", "GitHub Actions", "Prometheus", "Grafana", "Terraform", "ECK"]
    },
    {
      name: "Terraform AWS IaC",
      description: "AWS infrastructure as code using Terraform with IAM Identity Center SSO. No static access keys.",
      link: null,
      github: "https://github.com/digamber-dwivedi/terraform",
      tech: ["Terraform", "AWS", "EC2", "VPC", "IAM"]
    },
    {
      name: "DB Backup K8s",
      description: "Automated PostgreSQL backup to S3 via Kubernetes CronJob.",
      link: null,
      github: "https://github.com/digamber-dwivedi/db-backup-k8s",
      tech: ["Kubernetes", "PostgreSQL", "AWS S3", "CronJob"]
    }
  ];

  return (
    <div className="bg-navy py-20 px-8" id="projects">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-light mb-2">
          <span className="text-green font-mono text-xl">04. </span>
          Projects
        </h2>
        <div className="w-64 h-px bg-navy-lighter mb-10"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((project) => (
            <div key={project.name} className="bg-navy-light p-6 rounded border border-navy-lighter hover:border-green transition-all flex flex-col justify-between">
              <div>
                <h3 className="text-slate-light font-bold text-xl mb-3">{project.name}</h3>
                <p className="text-slate text-sm mb-4">{project.description}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tech.map(t => (
                    <span key={t} className="text-green font-mono text-xs">{t}</span>
                  ))}
                </div>
              </div>
              <div className="flex gap-4">
                <a href={project.github} target="_blank" rel="noreferrer" className="text-slate hover:text-green transition-all text-sm">
                  GitHub →
                </a>
                {project.link && (
                  <a href={project.link} target="_blank" rel="noreferrer" className="text-slate hover:text-green transition-all text-sm">
                    Live →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;